import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "homepage-banner"
  }, [_c("div", {
    staticClass: "swiper-container"
  }, [_c("div", {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.solutionList, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "swiper-slide swiper-lazy",
      staticStyle: {
        overflow: "hidden"
      }
    }, [_c("div", {
      staticClass: "bottom-bg",
      style: {
        background: `url(${item.picture_url}) no-repeat`
      }
    }, [_c("div", {
      staticClass: "play-bg",
      style: {
        background: `url(${item.dynamic_url})`
      }
    })]), _c("div", {
      staticClass: "banner-main area"
    }, [_c("div", {
      staticClass: "banner-title"
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), _c("div", {
      staticClass: "banner-content"
    }, [_vm._v(" " + _vm._s(item.subtitle) + " ")]), _c("div", {
      staticClass: "banner-see",
      on: {
        click: function ($event) {
          return _vm.$router.push(item.cnt_url);
        }
      }
    }, [_vm._v(" 立即查看 ")])])]);
  }), 0), _vm.solutionList.length > 1 ? _c("div", {
    staticClass: "swiper-pagination area"
  }) : _vm._e(), _c("div", {
    staticClass: "tab-container"
  }, [_c("div", {
    staticClass: "banner-tab area"
  }, _vm._l(_vm.tabList, function (cItem, cIndex) {
    return _c("div", {
      key: cIndex,
      staticClass: "banner-tabitem",
      on: {
        click: function ($event) {
          return _vm.toSee(cItem.cnt_url);
        }
      }
    }, [_c("div", {
      staticClass: "tab-title"
    }, [_vm._v(_vm._s(cItem.title))]), _c("div", {
      staticClass: "icon-right"
    })]);
  }), 0)])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };